import { render, staticRenderFns } from "./FeedPhoto.vue?vue&type=template&id=3b87089a"
import script from "./FeedPhoto.vue?vue&type=script&lang=js"
export * from "./FeedPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports